/**
 * Scroll to top of the page
 */
export function scrollToTop() {
  window.scrollTo(0, 0);
}
